import { NgModule } from "@angular/core";

import { ServerStyleDirective } from "./server-style.directive";

const DIRECTIVES = [ServerStyleDirective];

@NgModule({
	imports: [],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class ServerStyleModule {}
